import { useState } from "react";
import {
  Dialog as MUIDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import { TimeField } from "component/atoms/time-field";
import { zohoApi } from "zohoApi";
import { Controller, useForm } from "react-hook-form";
import { useEventConfigArray } from "hook/use-event-config-array";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export function CreateDialog({ dialogOpen, handleCloseDialog, selectedEvent, revalidate }) {
  const settingArray = useEventConfigArray();
  const [selectedSetting, setSelectedSetting] = useState(null);
  // console.log({ selectedSetting });
  const onlyDate =
    selectedSetting?.allDay || selectedSetting?.startTimeField?.data_type === "date" || selectedSetting?.endTimeField?.data_type === "date";

  const selectedActivity = settingArray?.find((el) => el?.setting_id === selectedEvent.setting_id);

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { dirtyFields },
    reset,
  } = useForm({});

  const onSubmit = async (data) => {
    /*  console.log({ data });
    return; */
    const {
      selectedActivity: { module, startTimeField, endTimeField, popupFields },
      ...inputs
    } = data || {};

    const { startTime, endTime, ...rest } = inputs || {};
    endTimeField.value = endTime.toISOString();
    startTimeField.value = startTime.toISOString();
    // console.log({ popupFields, rest });
    const valObj = {};
    popupFields?.forEach((el) => {
      valObj[el?.display_label] = el;
    });
    Object.keys(rest)?.forEach((el) => {
      valObj[el].value = rest[el];
      // console.log(valObj[el]);
    });
    const fieldValues = Object.values(valObj);
    fieldValues.push(startTimeField);
    fieldValues.push(endTimeField);
    const recordData = {};
    fieldValues?.forEach((el) => {
      let val = el.value;
      const date = el?.data_type === "date";
      const dateTime = el?.data_type === "datetime";

      if (date) {
        // need to work on date format
        val = dayjs.utc(val).format("YYYY-MM-DDTHH:mm:ssZ");
      }

      if (dateTime) {
        val = dayjs.utc(val).format("YYYY-MM-DDTHH:mm:ssZ");
      }

      recordData[el.api_name] = val;
    });
    const moduleApiName = module.api_name;
    console.log({ moduleApiName, recordData });
    const { data: respData } = await zohoApi.record.insertRecord({
      moduleApiName,
      recordData,
    });
    console.log({ respData });
    revalidate?.();
    handleCloseDialog();
    // mutate({module,fieldValues});
  };

  return (
    <MUIDialog
      open={dialogOpen}
      onClose={handleCloseDialog}
      fullWidth={true}
      slotProps={{
        paper: {
          component: "form",
          onSubmit: handleSubmit(onSubmit),
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start",
        },
      }}
      // maxWidth={"xs"}
    >
      <DialogTitle>Create New Event</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <Grid container sx={{ pt: "1px" }}>
          <Grid size={4}>
            <Typography component="label" htmlFor="module-input" sx={{ color: "text.secondary" }}>
              Select Activity
            </Typography>
          </Grid>
          <Grid size={8}>
            <Controller
              name="selectedActivity"
              control={control}
              render={({ field }) => {
                const { onChange, ...rest } = field;
                return (
                  <Autocomplete
                    {...rest}
                    id="selected-activity-input"
                    filterSelectedOptions
                    disabled={!settingArray}
                    options={settingArray}
                    getOptionLabel={(option) => option?.activity || ""}
                    onChange={(e, value, reason) => {
                      setSelectedSetting(value);
                      onChange(value);
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        placeholder="Select Activity"
                        // variant="standard"
                      />
                    )}
                  />
                );
              }}
            />
          </Grid>
        </Grid>

        {selectedSetting?.popupFields?.length > 0 ? (
          <TimeField
            disabled={!selectedSetting}
            Controller={Controller}
            control={control}
            onlyDate={onlyDate}
            watch={watch}
            selectedActivity={selectedActivity}
          />
        ) : null}

        {selectedSetting?.popupFields?.map((el) => (
          <Grid container key={el?.display_label}>
            <Grid size={4}>
              <Typography component="label" htmlFor={el?.display_label} sx={{ color: "text.secondary" }}>
                {el?.display_label}
              </Typography>
            </Grid>
            <Grid size={8}>
              <Controller
                name={el?.display_label}
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    required
                    sx={{ width: "100%" }}
                    id={el?.display_label}
                    placeholder={el?.display_label}
                    variant="standard"
                  />
                )}
              />
            </Grid>
          </Grid>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleCloseDialog();
            setSelectedSetting(null);
            reset();
          }}
          size="small"
          variant="outlined"
          sx={{ textTransform: "capitalize" }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          size="small"
          variant="contained"
          sx={{ textTransform: "capitalize" }}
          disabled={!selectedSetting || !(dayjs(watch("startTime")).isValid() && dayjs(watch("endTime")).isValid())}
        >
          Save
        </Button>
      </DialogActions>
    </MUIDialog>
  );
}
